import React, { useContext, useEffect } from 'react'
import ContentHeader from '@Components/ContentHeader'
import './index.scss'
import { CourierPreferences, useCourier } from '@trycourier/courier-react'
import { StoresContext } from '@App/contexts'

const NotificationPreferencesScene = () => {
    const { notificationStore, authStore, userStore } = useContext(StoresContext)
    const notificationToken = notificationStore.notificationToken
    const courier = useCourier()

    useEffect(() => {
        if (userStore.userInfo.exposedId && authStore.isLoggedIn && notificationToken) {
            courier.shared.signIn({ userId: userStore.userInfo.exposedId, jwt: notificationToken })
        }
    }, [notificationToken])

    if (!userStore.userInfo.exposedId || !authStore.isLoggedIn || !notificationToken) {
        return null
    }

    return (
        <main className="notification-preferences">
            <div className="notification-preferences__content">
                <ContentHeader
                    title="Notification Preferences"
                    descriptionElement={
                        <p>For the categories listed below, you can choose how you’d like to be reached.</p>
                    }
                />
                <CourierPreferences
                    mode="light"
                    title="Notification Preferences"
                    subtitle="For the categories listed below, you can choose how you’d like to be reached."
                />
            </div>
        </main>
    )
}

export default NotificationPreferencesScene
